<template>
  <span ref="textfield" :style="disabled ? 'color: #ABABAB': ''">
    <v-row v-if="label || $slots.label" class="my-0 ellipsis" no-gutters>
      <div class="_subtitleFormFont">
        <slot name="label">
          <span :class="[{'smallFontLabel': smallFontLabel}]">{{ label }}:</span>
        </slot>
      </div>
    </v-row>
    <v-text-field
      ref="textField"
      class="pa-0 noMarginPreffix textfield-v2"
      dense
      filled
      outlined
      flat
      :spellcheck="false"
      v-model="selectedValue"
      :autofocus="autofocus"
      :hide-details="hideDetails"
      :required="required"
      :validate-on-blur="validateOnBlur"
      :error-messages="errorMessages"
      :disabled="disabled"
      :readonly="readonly"
      :loading="loading"
      :label="labelForm"
      :solo="solo"
      :placeholder="placeholder"
      :background-color="backgroundColor"
      :style="`width: ${width}; height: ${height}; border-radius: 8px; max-width: 100%; ${customStyle}`"
      :rules="rules"
      :type="type"
      :suffix="suffix"
      :prefix="prefix"
      :maxLength="maxLength"
      @change="$emit('change', $event)"
      @input="$emit('input', $event)"
      @blur="emitBlur"
      @click.stop="$emit('click', $event)"
      @keydown="emitKeyDown"
      @keyup="$emit('keyup', $event)"
      @keypress="$emit('keypress', $event)"
      @keypress.enter="$emit('keypressEnter', $event)"
    >

      <template v-slot:prepend-inner>
        <i :class="`${iconPosition} ${icon}`"></i>
      </template>

      <template v-if="appendIcon" v-slot:append>
        <v-tooltip :disabled="!appendIconTooltip" color="#192B46" bottom max-width="250px">
          <template v-slot:activator="{ on }">        
            <i v-on="on" :class="`${appendIcon}`" @click="$emit('appendClick')" style="cursor: pointer; padding-top: 6px"></i>
          </template>
          
          <div>
            {{appendIconTooltip}}
          </div>
        </v-tooltip>
      </template>

    </v-text-field>
  </span>
</template>

<script>
  export default {
    props: {
      width: {type: String, default: '100%'},
      height: {type: String, default: '40px'},
      customStyle: {type: String},
      backgroundColor: {type: String, default: '#F6F7F7'},
      showBorder: {type: Boolean, default: true},
      icon: {type: String},
      iconSize: {type: String, default: 'small'},
      iconPosition: {type: String, default: 'mt-1 mr-1'},
      value: { required: true },
      label: {type: String, required: false},
      labelForm: {type: String, required: false},
      placeholder: {type: String, required: false},
      required: {type: Boolean, default: false},
      validateOnBlur: {type: Boolean, default: false},
      disabled: {type: Boolean, default: false},
      loading: {type: Boolean, default: false},
      solo: {type: Boolean, default: false},
      maxLength: {default: null},
      errorMessages: {required: false, default: null},
      rules: {required: false},
      readonly: {required: false, default: false},
      hideDetails: {required: false, default: true},
      type: {required: false, default: 'text'},
      minValueForNumber: {required: false},
      suffix: {required: false},
      prefix: {required: false},
      currency: {type: Boolean, default: false},
      appendIcon: {type: String},
      appendIconTooltip: {type: String},
      autofocus: {type: Boolean, default: false},
      smallFontLabel: {type: Boolean, default: false}
    },

    data () {
      return {
        currencyOptions: {
          currency: null,
          autoDecimalMode: true
        },
        preventUpdated: false
      }
    },

    computed: {
      selectedValue: {
        get () {
          return this.value
        },
        set (v) {
          return this.$emit('input', v)
        }
      }
    },

    updated () {
      if (!this.preventUpdated && this.type === 'number' && typeof this.minValueForNumber === 'number') {
        const value = this.selectedValue
        const castedNumber = Number(value)
        if (castedNumber && castedNumber < this.minValueForNumber) this.selectedValue = this.minValueForNumber
     }
    },

    mounted () {
      if (!this.showBorder) {
        const span = this.$refs.textfield
        span.classList.add('noBorder')
      }
    },

    methods: {
      emitKeyDown ($event) {
        const preventList = ['Backspace', 'Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9', 'Digit0']

        if (this.type === 'number' && this.minValueForNumber) {
          if (preventList.includes($event.code)) {
            this.preventUpdated = true
            setTimeout(() => {this.preventUpdated = false}, 200)
          } else $event.preventDefault()
        }
        
        this.$emit('keydown', $event)
      },

      emitBlur ($event) {
        if (this.type === 'number' && this.minValueForNumber) {
          const value = this.selectedValue
          if (Number(value) < this.minValueForNumber || !value) this.selectedValue = this.minValueForNumber
        }   

        this.$emit('blur', $event)
      }
    }
  }
</script>

<style scoped>
.v-text-field--outlined:not(.error--text) /deep/ fieldset {
  /* border: #EDEDF1 1px solid !important; */
  border-color: #EDEDF1 !important;
}

.noBorder .v-text-field--outlined /deep/ fieldset {
  border: #EDEDF1 0px solid !important;
}

.ellipsis {
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ellipsis span {
  overflow: hidden;
  text-overflow: ellipsis;  
}

.smallFontLabel {
  font-size: 0.7rem;
}
</style>

<style>
.noMarginPreffix .v-input__control .v-input__slot .v-text-field__slot .v-text-field__prefix {
  margin: 0 !important;
}

.textfield-v2 {
  font-size: 0.9rem !important;
  font-weight: 400 !important;
}  
</style>
